import { TranslationHelper } from "app/helpers/translationHelper";
import { EventIncidentType } from "app/types/eventType";
import { FormattedMessage } from "react-intl";
import "../../IceHockeyPhase.scss";

export default function IceHockeyPhaseLive(props: {
  eventIncidents: EventIncidentType[];
  eventPhase: string;
}) {
  const { eventPhase, eventIncidents } = props;

  return (
    <div className="icehockey-phase">
      <div className="icehockey-phase__info">
        <FormattedMessage
          tagName="span"
          id={TranslationHelper.getTranslationIdForMarket(
            eventPhase,
            "",
            "",
            true
          )}
        />
        <div className="eventPhase">{eventIncidents[0]["remainingTime"]}</div>
      </div>
    </div>
  );
}
